import * as yup from 'yup';

export const initialValues = {
  reviewStars: '',
  title: '',
  review: '',
  recommendationRating: '',
};

export const schemaProp = {
  review: yup
    .string()
    .required('Requerido')
    .min(10, 'Minimo')
    .max(100, 'Maximo'),
    title: yup.string().required('Requerido').min(5, 'Mínimo 5 caracteres').max(50, 'Máximo 50 caracteres'),
  reviewStars: yup.number().required('Requerido'),
  recommendationRating: yup.number().required('Requerido'),
};

export const schema = yup.object().shape(schemaProp);

export const GENERIC_OPTIONS = [
  { label: 'Item 1', value: 1 },
  { label: 'Item 2', value: 2 },
  { label: 'Item 3', value: 3 },
];

export const STAR_OPTIONS = Array.from({ length: 5 }, (_, index) => ({
  value: index,
}));

export const RECOMMENDATION_RATING_OPTIONS = Array.from(
  { length: 10 },
  (_, index) => ({ value: index + 1 })
);
